import { render, staticRenderFns } from "./BlueMountains.vue?vue&type=template&id=2c8da822&"
import script from "./BlueMountains.vue?vue&type=script&lang=js&"
export * from "./BlueMountains.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports